exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/core-js/library/modules/_object-pie.js
// module id = ../../../node_modules/core-js/library/modules/_object-pie.js
// module chunks = 0